// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { Box, IconButton, Popover } from '@mui/material';

interface InfoWithPopoverProps {
  popoverContent: React.ReactNode;
  color?: string;
}
export const InfoWithPopover: React.FC<InfoWithPopoverProps> = ({ popoverContent, color }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box>
      <IconButton size="small" onClick={handleClick}>
        <InfoOutlined sx={{ color: color || ((t) => t.palette.grey[600]) }} fontSize="small" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {popoverContent}
      </Popover>
    </Box>
  );
};
